import { ComponentType, lazy } from 'react'

import { captureError } from 'conversations/utils/logRocket'

export const importRetry = (
  importCallback: () => Promise<{ default: any }>,
  retriesLeft = 5,
  interval = 1000
): Promise<{ default: any }> => {
  return new Promise((resolve, reject) => {
    importCallback()
      .then(resolve)
      .catch((err) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            captureError(err, 'Lazy retry failed')
            reject(err)
            return
          }

          importRetry(importCallback, retriesLeft - 1, interval).then(resolve, reject)
        }, interval)
      })
  })
}

type LazyReturnType = ReturnType<typeof lazy>
type ImportRetryArguments = Parameters<typeof importRetry>

export const lazyRetry = <T extends ComponentType<any>>(
  ...args: ImportRetryArguments
): LazyReturnType => lazy<T>(() => importRetry(...args))
